import { render, staticRenderFns } from "./Bi.vue?vue&type=template&id=0d2e253f"
import script from "./Bi.vue?vue&type=script&lang=js"
export * from "./Bi.vue?vue&type=script&lang=js"
import style0 from "../assets/bi.styl?vue&type=style&index=0&prod&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports